export default __webpack_public_path__ + "static/media/provider-icon3.5d784dff.svg";